import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Nav } from "./components/landing/Nav";
import { Hero } from "./components/landing/Hero";
import { ChainsMarquee } from "./components/landing/ChainsMarquee";
import { Capabilities } from "./components/landing/Capabilities";
import { CardP2P } from "./components/landing/CardP2P";
import { HowItWorks } from "./components/landing/HowItWorks";
import { CheckoutDemo } from "./components/landing/CheckoutDemo";
import { StatsBand } from "./components/landing/StatsBand";
import { Security } from "./components/landing/Security";
import { Pricing } from "./components/landing/Pricing";
import { Testimonials } from "./components/landing/Testimonials";
import { Faq } from "./components/landing/Faq";
import { FinalCta } from "./components/landing/FinalCta";
import { Footer } from "./components/landing/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    const raf = (time) => {
      lenis.raf(time);
      requestAnimationFrame(raf);
    };
    requestAnimationFrame(raf);
    const onAnchor = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const el = document.querySelector(a.getAttribute("href"));
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el, { offset: -80 });
      }
    };
    document.addEventListener("click", onAnchor);
    return () => {
      document.removeEventListener("click", onAnchor);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Toaster position="bottom-right" richColors />
      <Nav />
      <main>
        <Hero />
        <ChainsMarquee />
        <Capabilities />
        <CardP2P />
        <HowItWorks />
        <CheckoutDemo />
        <StatsBand />
        <Security />
        <Pricing />
        <Testimonials />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}

export default App;
